import { AxiosRequestConfig } from 'axios'

import { ParametersDownload } from './types'

const getRewards = ({ startDate, endDate, storeIds }: ParametersDownload): AxiosRequestConfig => {
  const params = {
    ...(startDate ? { startDate: startDate.toISOString() } : {}),
    ...(endDate ? { endDate: endDate.toISOString() } : {}),
    ...(storeIds && storeIds.length > 0 ? { storeIds: storeIds.join(',') } : {}),
  }

  return {
    url: 'dashboard/rewards',
    method: 'GET',
    params,
  }
}

export { getRewards }
